"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _default = function _default(ref, handler) {
  var handlerRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    handlerRef.current = handler;
  });
  var callback = (0, _react.useCallback)(function (e) {
    var _ref$current;
    console.log('click event', e.target, (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.contains(e.target));
    try {
      var _ref$current2;
      if ((_ref$current2 = ref.current) !== null && _ref$current2 !== void 0 && _ref$current2.contains(e.target)) {
        return;
      }
      if (handlerRef.current) {
        handlerRef.current(e);
      }
    } catch (_unused) {}
  }, []);
  (0, _react.useEffect)(function () {
    document.addEventListener('click', callback);
    return function () {
      document.removeEventListener('click', callback);
    };
  }, [ref]);
};
exports.default = _default;